module.exports = __webpack_public_path__ + "img/notconfirmed.2bdfa20f.svg";